import { buildElement } from '../../../utils/element'
import * as Mustache from 'mustache'
import { TemplateOptions } from '../../../models/render-options'
import { widgetState } from '../../../store/customizations/index'

export const buildTemplate = (options: TemplateOptions, template: string) => {
  const html = Mustache.render(template, {
    ...options,
    checkedFn: () => {
      return options.checked ? 'checked=true' : ''
    },
    checkedClassFn: () => {
      return options.checked ? 'yotpo-checked' : ''
    }
  })

  const element = buildElement('div', options.classString, options.attributes || {})
  element.innerHTML = html

  element.addEventListener('click', displaySelectedElement(options.id))

  return element
}

export const displaySelectedElement = (value: string) => () => {
  document.querySelectorAll('[data-selling-plan-group-frequency-id]')
    .forEach(element => {
      const isClickedOn = element.getAttribute('data-selling-plan-group-frequency-id') === value
      const canClose = widgetState.customizations.selectionType !== 'radio-and-dropdown' || !widgetState.customizations.styles.selectedRadio.openByDefault
      if (canClose) {
        (element as HTMLElement).style.display = isClickedOn ? 'block' : 'none'
      }

      const inputEl = document.querySelector(`[data-seling-plan-group-id="${value}"] .yotpo-radio-label-input`)
      pickElement(inputEl as HTMLElement, isClickedOn)
    })
  document.querySelectorAll('.yotpo-radio-container[data-seling-plan-group-id]')
    .forEach(element => {
      const isClickedOn = element.getAttribute('data-seling-plan-group-id') === String(value)
      pickElement(element as HTMLElement, isClickedOn)
    })
}

const pickElement = (element: HTMLElement, isClickedOn: boolean): void => {
  const currnectClass2 = element.getAttribute('class')
    .replace('yotpo-not-selected', '')
    .replace('yotpo-selected', '')
  const klass = isClickedOn ? 'yotpo-selected' : 'yotpo-not-selected'
  element.setAttribute('class', `${currnectClass2} ${klass}`)
}
